import React from "react";
import { useTranslation } from "react-i18next";
import { useGetParametersForView } from "security-app/hooks/useEventProceduresAPI";
import { FormikInput, Spinner } from "components/common";
import { Col } from "security-app/components/common/FormBaseStyles";
import WatchlistParameter from "watchlist/WatchlistParameter";
import LookupTableParameter from "views/logic/parameters/LookupTableParameter";
const IMPLICITLY_BOUND_TYPES = [WatchlistParameter.type, LookupTableParameter.type];
function EventProceduresParametersForm({ viewType, readOnly, viewId = "" }) {
  const { t } = useTranslation("enterprise_security_events");
  const { parameters: viewParameters, fetchingParameters } = useGetParametersForView({ viewId, type: viewType });
  const parameters = viewParameters == null ? void 0 : viewParameters.filter(({ type }) => !IMPLICITLY_BOUND_TYPES.includes(type));
  if (!fetchingParameters && !parameters || (parameters == null ? void 0 : parameters.length) < 1) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, fetchingParameters ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, viewType === "dashboard" ? t("parameters_form.notice_dashboard") : t("parameters_form.notice_search")), parameters.map((parameter) => {
    const { name, title, optional } = parameter;
    return /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0.3rem", $align: "stretch", key: `${name}-parameter` }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        type: "text",
        name: `parameters.${name}`,
        id: name,
        label: title,
        validate: (value) => !optional && !value && t("parameters_form.parameter_required"),
        required: !optional,
        disabled: readOnly
      }
    ));
  })));
}
export default EventProceduresParametersForm;
